import styled from 'styled-components';

import bgInit from '@/assets/img/gift-shelf-init.png';
export default styled.div`
  .goods-shelf-text-wrap {
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #e5e5e5;
    padding: 16px 16px 21px;
    gap: 0 48px;
    display: flex;
  }
  .table-wrap {
    background: #f5f5f5;
    border-radius: 6px 6px 0px 0px;
    display: flex;
    .table-th {
      height: 48px;
      font-size: 16px;
      font-weight: 500;
      color: #212121;
      line-height: 48px;
      text-align: center;
    }
    .table-th-shrink {
      flex-shrink: 0;
    }
    &.table-wrap-background {
      background: #ffffff;
      background-image: url(${bgInit});
      background-position: 2px 2px;
      background-size: 7px 7px;
      background-repeat: no-repeat;
    }
  }
  .export-wrapper {
    margin: 32px 0 16px;
    height: 34px;
    display: flex;
    gap: 0 16px;
    align-items: center;
    .export {
      width: 107px;
      border-radius: 24px;
      color: #fff;
      background-color: #2196f3;
      .MuiSvgIcon-root {
        margin-right: 8px;
      }
    }
  }
  .gift-title {
    height: 20px;
    font-size: 14px;
    font-weight: 500;
    color: #212121;
    line-height: 20px;
  }
`;
